var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vuFormRangeSlider", class: _vm.classes }, [
    _vm.hasLabel && !_vm.p.labelAfter
      ? _c(
          "label",
          {
            staticClass: "vuFormInput__label",
            attrs: { id: _vm.p.id + "-label", for: _vm.p.id + "-slider" },
          },
          [_vm._t("default")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "vuFormRangeSlider__fieldWrap" }, [
      _c("div", {
        ref: "slider",
        staticClass: "vuFormRangeSlider__slider",
        attrs: { disabled: _vm.p.disabled },
      }),
      _vm._v(" "),
      _c("div", { ref: "handleSlot" }, [_vm._t("handle")], 2),
      _vm._v(" "),
      _vm.p.error
        ? _c(
            "div",
            { staticClass: "vuFormInput__error" },
            [
              _vm._t(
                "error",
                function () {
                  return [_vm._v(_vm._s(_vm.p.error))]
                },
                { error: _vm.p.error }
              ),
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.hasLabel && _vm.p.labelAfter
      ? _c(
          "label",
          {
            staticClass: "vuFormInput__label",
            attrs: { id: _vm.p.id + "-label", for: _vm.p.id + "-input" },
          },
          [_vm._t("default")],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }